package es.subastia.main

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Bookmarks
import androidx.compose.material.icons.filled.Favorite
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.Person
import androidx.compose.material3.Icon
import androidx.compose.material3.NavigationBar
import androidx.compose.material3.NavigationBarItem
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import es.subastia.auctionlist.AuctionListScreen
import es.subastia.favorites.FavoritesScreen
import es.subastia.navigation.NavRoute
import es.subastia.navigation.Navigator
import es.subastia.profile.ProfileScreen
import es.subastia.savedsearches.SavedSearchesScreen
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource
import subastia.composeapp.generated.resources.Res
import subastia.composeapp.generated.resources.nav_favorites
import subastia.composeapp.generated.resources.nav_home
import subastia.composeapp.generated.resources.nav_profile
import subastia.composeapp.generated.resources.nav_saved

enum class MainTab(
    val route: NavRoute,
    val labelRes: StringResource,
    val icon: ImageVector,
) {
    Home(NavRoute.Main, Res.string.nav_home, Icons.Default.Home),
    Saved(NavRoute.SavedSearches, Res.string.nav_saved, Icons.Default.Bookmarks), // Saved searches
    Favorites(NavRoute.Favorites, Res.string.nav_favorites, Icons.Default.Favorite), // Saved auctions
    Profile(NavRoute.Profile, Res.string.nav_profile, Icons.Default.Person),
}

@Composable
fun MainScreen(navigator: Navigator) {
    val backstack by navigator.backstack.collectAsState()
    val currentRoute = backstack.lastOrNull() ?: NavRoute.Main

    val currentTab = when (currentRoute) {
        NavRoute.SavedSearches -> MainTab.Saved
        NavRoute.Favorites -> MainTab.Favorites
        NavRoute.Profile -> MainTab.Profile
        else -> MainTab.Home
    }

    Scaffold(
        bottomBar = {
            NavigationBar {
                MainTab.entries.forEach { tab ->
                    NavigationBarItem(
                        selected = currentTab == tab,
                        onClick = {
                            if (currentTab != tab) {
                                navigator.navigateTo(tab.route)
                            }
                        },
                        icon = { Icon(tab.icon, contentDescription = stringResource(tab.labelRes)) },
                        label = { Text(stringResource(tab.labelRes)) },
                    )
                }
            }
        },
    ) { padding ->
        Box(modifier = Modifier.padding(bottom = padding.calculateBottomPadding()).fillMaxSize()) {
            when (currentTab) {
                MainTab.Home -> AuctionListScreen(
                    navigator,
                    (currentRoute as? NavRoute.AuctionList) ?: NavRoute.AuctionList()
                )
                MainTab.Saved -> SavedSearchesScreen(navigator)
                MainTab.Favorites -> FavoritesScreen(navigator)
                MainTab.Profile -> ProfileScreen(navigator)
            }
        }
    }
}
